export default __webpack_public_path__ + "static/media/mail.9f1bba72.svg";